export default function DialogBubble() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="mode_comment">
        <mask
          id="mask0_373_3"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="34"
          height="34"
        >
          <rect id="Bounding box" width="34" height="34" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_373_3)">
          <path
            id="mode_comment_2"
            d="M5.66646 25.499C4.8873 25.499 4.22028 25.2216 3.66542 24.6668C3.11056 24.1119 2.83313 23.4449 2.83313 22.6657V5.66573C2.83313 4.88656 3.11056 4.21955 3.66542 3.66469C4.22028 3.10983 4.8873 2.8324 5.66646 2.8324H28.3331C29.1123 2.8324 29.7793 3.10983 30.3342 3.66469C30.889 4.21955 31.1664 4.88656 31.1664 5.66573V31.1657L25.4998 25.499H5.66646Z"
            fill="white"
          />
          <path
            id="auto_fix"
            d="M19.345 13.2624L18.293 10.9899L16.0231 9.93676L18.293 8.88363L19.345 6.61108L20.3969 8.88363L22.6668 9.93676L20.3969 10.9899L19.345 13.2624ZM12.7664 18.0249L11.7145 15.7524L9.44458 14.6992L11.7145 13.6461L12.7664 11.3735L13.8183 13.6461L16.0883 14.6992L13.8183 15.7524L12.7664 18.0249ZM20.2894 20.7777L19.2375 18.5052L16.9676 17.4521L19.2375 16.3989L20.2894 14.1264L21.3413 16.3989L23.6112 17.4521L21.3413 18.5052L20.2894 20.7777Z"
            fill="#B78242"
          />
        </g>
      </g>
    </svg>
  );
}
